export default {
    title: 'Maintenance Announcement',
    description: 'We will be undergoing scheduled maintenance on {date} from approximately {startTime} to {endTime}. During this time, the site will be temporarily locked, and access will not be available. We appreciate your understanding and patience as we work to improve our services.'
}